<template>
  <div class="page">
    <p class="p1">
      我的账户
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div class="ye-class">
      <p>
        <span>500</span>
        <span style="font-size: 14px;">元</span>
      </p>
      <p style="font-size: 15px;">赠送金额30元</p>
    </div>
    <div class="money-class">
      <div v-for="(item,index) in dataList" :key="index" :class="{cur: cardIndex===index}" @click="tabMoney(index)">
        <p style="font-size:15px">{{item.qian}}元</p>
        <p>赠送{{item.song}}元</p>
      </div>
    </div>
  </div>
</template>
<script>
import { wx_order } from "@/api/api.js"; 
export default {
  data() {
    return {
      cardIndex: 0,
      dataList:[
        {
          qian:"200",
          song:"10"
        },
        {
          qian:"300",
          song:"15"
        },
        {
          qian:"500",
          song:"30"
        },
      ]
    };
  },
  computed: {},
  methods: {
    goBack(){
      this.$router.go(-1);
    },
    initData(){
      
    },
    tabMoney(index) {
      this.cardIndex = index;
    },
  },
  created() {
    this.initData()
  },
  mounted() {
    window.document.title = "我的账户";
  },
};
</script>
<style scoped lang="less">
  .cur {
    background: #FF6666;
    border: 1px solid #FF6666 !important;
  }
  .cur p {
    color: #fff;
  }
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }
    .ye-class{
      width: 100%;
      text-align: center;
      background: #F94040;
      p{
        padding: 10px 0;
        color: #fff;
        box-sizing: border-box;
        font-size: 17px;
      }
    }
    .money-class{
      width: 100%;
      margin-top: 20px;
      font-size: 12px;
      padding: 10px 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      div{
        width: 27%;
        text-align: center;
        border: 1px solid #CACDD1;
        border-radius: 10px;
        p{
          padding: 2px;
        }
      }
    }
  }
</style>

